import {
  SimpleForm,
  ReferenceInput,
  SelectInput,
  TextInput,
  ImageInput,
  ImageField,
  LongTextInput
} from "react-admin";
import React from "react";
import { required } from "../../services/validate";
import { typeHotline } from "../../constant/TypeHotline";
import { SUPERADMIN } from "../../constant/TypeRole";

const HotlineForm = props => {
  const { record } = props;
  const role = localStorage.getItem("role");
  const project = JSON.parse(localStorage.getItem("project"));
  const filter = role ? (role === SUPERADMIN ? {} : { _id: project }) : {};
  return (
    <SimpleForm {...props}>
      <ReferenceInput
        disabled={record.project ? true : false}
        validate={[required()]}
        source="project"
        reference="project"
        filter={filter}
      >
        <SelectInput optionText="name" />
      </ReferenceInput>
      <TextInput source="name" label="ชื่อภาษาไทย" validate={[required()]} />
      <TextInput source="name_en" label="ชื่อภาษาอังกฤษ" validate={[required()]} />
      <TextInput source="name_jp" label="ชื่อภาษาญี่ปุ่น" validate={[required()]} />
      <TextInput source="name_zh" label="ชื่อภาษาจีน" validate={[required()]} />
      <TextInput source="tel" validate={[required()]} />
      <SelectInput
        source="type"
        label="Type"
        validate={[required()]}
        // defaultValue={1}
        choices={typeHotline}
      />
      {/* <ImageInput
                multiple={false}
                validate={[required()]}
                source="image" label="Image" accept="image/*">
                <ImageField source="url" title="title" />
            </ImageInput>
            <LongTextInput source="description" validate={[required()]} /> */}
    </SimpleForm>
  );
};

export default HotlineForm;



// WEBPACK FOOTER //
// ./src/components/hotline/HotlineForm.js